import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Select, MenuItem, FormControl, FormControlLabel, TextField, Radio, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../../../functions/apiService";
import Error from "../../Error/Error";
import { toast } from 'react-toastify';

export default function UserOptionForm() {
    // const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const {
        register,
        control,
        formState: { errors, isValid },
        handleSubmit,
        setError,
        setValue,
        getValues,
        reset,
        watch,

    } = useForm({
        defaultValues: {},
    });
    const onSubmit = (body) => {
        setLoading(false)
        ApiService.post('/createEmployeeOption', body)
            .then(() => {
                setLoading(true)
                toast.success('Success')
                // enqueueSnackbar('success', { variant: 'success' });
                reset()
            }).catch(() => {
                setLoading(true)
                toast.error('Error')
                // enqueueSnackbar('Error', { variant: 'error' });
            })
        // console.log('body', body);
    }
    return <>
        <Typography fontWeight='700' fontSize="16px">User Option</Typography>
        <form onSubmit={handleSubmit(onSubmit)} className="row">

            <div className="col-12 col-md-6 mt-2">
                <FormControl
                    required={true}
                    fullWidth
                >
                    <label style={{ fontSize: '14px' }}>User Option</label>
                    <TextField
                        className="mt-2"
                        InputProps={{
                            sx: {
                                height: '48px',
                            }
                        }}
                        sx={{ '& .MuiInputBase-input': { height: '39px' } }}
                        size="small"
                        {...register("Option", { required: "Option  is required." })}
                    />
                    {errors.Option && (<Error >{errors.Option?.message}</Error>)}
                </FormControl>
            </div>
            <div className="col-12 col-md-6 mt-2">
                <FormControl
                    required={true}
                    fullWidth
                >
                    <label style={{ fontSize: '14px' }}>User Value</label>
                    <TextField
                        className="mt-2"
                        InputProps={{
                            sx: {
                                height: '48px',
                            }
                        }}
                        sx={{ '& .MuiInputBase-input': { height: '39px' } }}
                        size="small"
                        {...register("Value", { required: "Value  is required." })}
                    />
                    {errors.Value && (<Error >{errors.Value?.message}</Error>)}
                </FormControl>
            </div>
            <div className="col-12 mt-3">
                <ButtonTheme disabled={!isValid || loading} color='primary' type='submit'>Add User Option</ButtonTheme>
            </div>


        </form>
    </>
}
